import { adminConfig } from 'src/environments/environment';

export function conditionallyLog(message?: any, ...optionalParams: any[]): void {
  if (adminConfig?.showConsoleLogs) {
    if (optionalParams?.length) {
      window.console.log(message, ...optionalParams);
    } else {
      window.console.log(message);
    }
  }
}
